import React from "react";
import { appColors, appRadius, appShadows } from "../../utils/appTheme";

/**
 * Tarjeta base al estilo app.
 * variant: "default" | "cream" | "hero" | "blue"
 * accent: "blue" (borde izquierdo de 3px, para novedades/multas)
 * onClick => pressable (feedback :active via CSS global).
 */
const AppCard = ({
  children,
  variant = "default",
  accent,
  onClick,
  padding = 18,
  radius = appRadius.card,
  style,
  ...rest
}) => {
  const variants = {
    default: {
      background: appColors.surface,
      border: `1px solid ${appColors.line}`,
      boxShadow: appShadows.soft,
      color: appColors.ink,
    },
    cream: {
      background: appColors.cream,
      border: `1px solid ${appColors.line2}`,
      boxShadow: appShadows.soft,
      color: appColors.ink,
    },
    hero: {
      background: appColors.surface,
      border: `1px solid ${appColors.line}`,
      boxShadow: appShadows.hero,
      color: appColors.ink,
    },
    blue: {
      background: appColors.blue,
      border: "1px solid transparent",
      boxShadow: appShadows.soft,
      color: appColors.onBlue,
    },
  };

  const Comp = onClick ? "button" : "div";

  return (
    <Comp
      onClick={onClick}
      style={{
        display: "block",
        width: "100%",
        textAlign: "left",
        borderRadius: radius,
        padding,
        cursor: onClick ? "pointer" : "default",
        borderLeft:
          accent === "blue" ? `3px solid ${appColors.blue}` : undefined,
        ...variants[variant],
        ...(accent === "blue" ? { borderLeftColor: appColors.blue } : null),
        ...style,
      }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export default AppCard;
